import { render, staticRenderFns } from "./QuizModal.vue?vue&type=template&id=0543acd4&scoped=true"
import script from "./QuizModal.vue?vue&type=script&lang=js"
export * from "./QuizModal.vue?vue&type=script&lang=js"
import style0 from "./QuizModal.vue?vue&type=style&index=0&id=0543acd4&prod&lang=scss&scoped=true"
import style1 from "./QuizModal.vue?vue&type=style&index=1&id=0543acd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543acd4",
  null
  
)

export default component.exports